import React, { useMemo } from 'react';
import { Button } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppDialog from '@shared/components/app-dialog/app-dialog.tsx';
import MoveToGroupAlert from '@modules/digital-signage/pages/devices/compnents/move-to-group-dialog/components/move-to-group-alert/move-to-group-alert.tsx';
import { applyMoveSelection } from '@modules/digital-signage/utils/digital-signage.utils.ts';
import {
  GroupSettingsFormValues,
  MoveDevicesDialogProps
} from '@modules/digital-signage/model/group-settings.model.ts';

const MoveDevicesDialog: React.FC<MoveDevicesDialogProps> = ({
  open,
  sourceDevices,
  isLoading,
  onClose,
  onSave
}) => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<GroupSettingsFormValues>();
  const formDevices = useWatch({ control, name: 'devices' });

  const selectedDevices = useMemo(() => {
    const formIds = new Set(formDevices.map((option) => option.id));
    return sourceDevices.filter(
      (device) => device._id && formIds.has(device._id)
    );
  }, [formDevices, sourceDevices]);

  return (
    <AppDialog
      open={open}
      width={720}
      title={t('move_to_group')}
      onClose={onClose}
      content={
        <div className="flex flex-col gap-6">
          <MoveToGroupAlert
            sourceDevices={sourceDevices}
            selectedDevices={selectedDevices}
            onChange={(nextSelected) =>
              setValue(
                'devices',
                applyMoveSelection(formDevices, sourceDevices, nextSelected),
                { shouldDirty: true }
              )
            }
          />

          <div className="flex justify-end gap-3">
            <Button variant="outlined" onClick={onClose}>
              {t('cancel')}
            </Button>
            <Button variant="contained" loading={isLoading} onClick={onSave}>
              {t('digital_signage_group_move_and_save')}
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default MoveDevicesDialog;
